import type { CompanyHighlight } from './types';

// Example content for the standalone "Company" page template (§11 of
// `docs/TEMPLATE_IMPROVEMENT_RECOMMENDATIONS.md`). A buyer who only needs a
// one-pager can delete `src/pages/Company.tsx` and its route in `App.tsx`;
// buyers who want a fuller "About" experience can expand on this page
// instead of overloading the home page's compact `AboutUs` section.
export const companyContent = {
    title: 'Our Company',
    intro: 'A closer look at the mission, milestones, and values that guide every shipment we deliver.',
    highlights: [
        {
            icon: 'compass',
            title: 'Our Mission',
            description:
                'Connect the world\u2019s most fertile agricultural regions to the markets that need them most, reliably and transparently.',
        },
        {
            icon: 'shield-check',
            title: 'Our Values',
            description:
                'Supply-chain integrity, rigorous quality control, and long-term partnerships over short-term margins.',
        },
        {
            icon: 'globe',
            title: 'Our Reach',
            description:
                'A vetted global sourcing network spanning multiple continents, built over years of on-the-ground relationships.',
        },
    ] satisfies CompanyHighlight[],
    milestones: [
        {
            year: '2025',
            description: 'Founded to bridge premium global sourcing with local demand.',
        },
        { year: '2025', description: 'Expanded into multi-continent sourcing partnerships.' },
        { year: '2026', description: 'Scaled logistics and quality-control operations.' },
        {
            year: '2026',
            description: 'Serving manufacturers, processors, and wholesalers nationwide.',
        },
    ],
};
